import { useState, useEffect } from 'react';
import { Bug, X } from 'lucide-react';
import ContactForm from '../pages/FormSpree';

export default function BugReportButton({ hiddenOnMobile }: { hiddenOnMobile?: boolean }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener('open-feedback', onOpen);
    return () => window.removeEventListener('open-feedback', onOpen);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <>
      <button
        className={`bug-fab${hiddenOnMobile ? ' fab--hidden-mobile' : ''}`}
        onClick={() => setOpen(true)}
        aria-label="Report a bug or share your feedback"
        title="Report a bug or share your feedback"
      >
        <Bug size={20} />
      </button>

      {open && (
        <div
          className="bug-modal-overlay"
          onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
          role="dialog"
          aria-modal="true"
          aria-label="Bug report"
        >
          <div className="bug-modal">
            <div className="bug-modal-header">
              <span className="bug-modal-title">Report a Bug / share your feedback</span>
              <button
                className="bug-modal-close"
                onClick={() => setOpen(false)}
                aria-label="Close"
                autoFocus
              >
                <X size={18} />
              </button>
            </div>
            <div className="bug-modal-body">
              <ContactForm />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
